export default __webpack_public_path__ + "static/slg-ennen-0ae4d60489bb755a9ffcda6954a6e512.jpg";